import { render, staticRenderFns } from "./Thank-you.vue?vue&type=template&id=12c23bd0"
import script from "./Thank-you.vue?vue&type=script&lang=js"
export * from "./Thank-you.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports